import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 832,
	height: 441,
	viewBox: "0 0 832 441",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M294.451 292.082H175.525",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M285.769 270.582H125.839",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.704 172.184H131.718L101.718 204.785H5.5",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 200C8.76142 200 11 202.239 11 205C11 207.761 8.76142 210 6 210C3.23858 210 1 207.761 1 205C1 202.239 3.23858 200 6 200Z",
			fill: "#0C0A0E",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M824.704 112.185H745.718L715.718 144.785H619.15",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M441.686 233.5C447.209 233.5 451.686 237.977 451.686 243.5C451.686 249.023 447.209 253.5 441.686 253.5C436.163 253.5 431.686 249.023 431.686 243.5C431.686 237.977 436.163 233.5 441.686 233.5Z",
			fill: "#1C1226"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M523.18 104.575C508.617 97.2011 497.741 92.3722 490.551 90.0883C472.09 84.2247 453.831 82.5 441.451 82.5C352.533 82.5 280.451 154.582 280.451 243.5C280.451 332.418 352.533 404.5 441.451 404.5V366.937C427.669 366.127 417.866 365.019 412.041 363.614C389.206 358.106 371.364 346.037 362.635 338.309C326.007 305.882 314.974 268.75 318.793 231.248C321.273 206.897 330.158 183.623 347.085 164.252C361.703 147.524 381.251 133.111 404.645 125.753C417.767 121.626 431.962 120.05 447.482 120.21C455.857 120.296 467.033 121.92 480.102 126.429C484.679 128.008 492.04 131.211 502.186 136.038L523.18 104.575Z",
			fill: "#28282D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M292.605 52.2246C235.746 96.6042 199.186 165.783 199.186 243.5C199.186 244.473 199.199 245.928 199.225 247.867H223.771C224.977 208.551 231.003 178.263 241.849 157.003C253.971 133.243 272.474 104.471 290.999 85.8865C297.337 79.5284 302.791 74.3787 309.195 71.0086",
			fill: "#1C1226"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M572.434 69.5971L589.313 51.0978C548.425 19.6786 497.237 1 441.686 1C307.757 1 199.186 109.571 199.186 243.5C199.186 244.473 199.199 245.928 199.225 247.867H223.771",
			stroke: "#1C1226"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M572.273 68.9242C535.875 41.6537 490.667 25.5 441.686 25.5C321.288 25.5 223.686 123.102 223.686 243.5C223.686 245.26 223.707 247.016 223.749 248.766",
			stroke: "#1C1226"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M589.932 180.865L629.131 165.429C628.708 164.425 628.389 163.672 628.173 163.172C597.049 91.011 525.266 40.5 441.686 40.5C330.775 40.5 240.639 129.446 238.717 239.898C238.704 240.697 238.693 241.898 238.686 243.5H280.686",
			stroke: "#454853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M589.843 180.936C565.427 123.095 508.18 82.5 441.451 82.5C352.533 82.5 280.451 154.582 280.451 243.5C280.451 332.418 352.533 404.5 441.451 404.5V366.937",
			stroke: "#28282D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M441.686 367C509.893 367 565.186 311.707 565.186 243.5C565.186 175.293 509.893 120 441.686 120C373.479 120 318.186 175.293 318.186 243.5C318.186 311.707 373.479 367 441.686 367Z",
			stroke: "#28282D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M563 219.582H681.926",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M684 214C681.239 214 679 216.239 679 219C679 221.761 681.239 224 684 224C686.761 224 689 221.761 689 219C689 216.239 686.761 214 684 214Z",
			fill: "#0C0A0E",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M284.451 359.446C319.445 408.509 376.829 440.5 441.686 440.5C469.743 440.5 496.402 434.513 520.455 423.747",
			stroke: "#1C1226"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M441.686 330.5C489.735 330.5 528.686 291.549 528.686 243.5C528.686 195.451 489.735 156.5 441.686 156.5C393.637 156.5 354.686 195.451 354.686 243.5C354.686 291.549 393.637 330.5 441.686 330.5Z",
			stroke: "#1C1226",
			strokeWidth: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M441.686 295.5C470.405 295.5 493.686 272.219 493.686 243.5C493.686 214.781 470.405 191.5 441.686 191.5C412.967 191.5 389.686 214.781 389.686 243.5C389.686 272.219 412.967 295.5 441.686 295.5Z",
			stroke: "#28282D",
			strokeWidth: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M559 282.5L620.863 304.156",
			stroke: "#454853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M548.5 305.5L584.628 325.722",
			stroke: "#454853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M523.18 104.575L502.187 136.038",
			stroke: "#454853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M826 107C828.761 107 831 109.239 831 112C831 114.761 828.761 117 826 117C823.239 117 821 114.761 821 112C821 109.239 823.239 107 826 107Z",
			fill: "#040207",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M619 298C621.761 298 624 300.239 624 303C624 305.761 621.761 308 619 308C616.239 308 614 305.761 614 303C614 300.239 616.239 298 619 298Z",
			fill: "#0C0A0E",
			stroke: "#454853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M581 318C583.761 318 586 320.239 586 323C586 325.761 583.761 328 581 328C578.239 328 576 325.761 576 323C576 320.239 578.239 318 581 318Z",
			fill: "#0C0A0E",
			stroke: "#454853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M176 287C178.761 287 181 289.239 181 292C181 294.761 178.761 297 176 297C173.239 297 171 294.761 171 292C171 289.239 173.239 287 176 287Z",
			fill: "#0C0A0E",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.5 266C127.538 266 130 268.462 130 271.5C130 274.538 127.538 277 124.5 277C121.462 277 119 274.538 119 271.5C119 268.462 121.462 266 124.5 266Z",
			fill: "#0C0A0E",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M647.204 414H568.218L538.218 381.399H442",
			stroke: "#28282D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M646 409C648.761 409 651 411.239 651 414C651 416.761 648.761 419 646 419C643.239 419 641 416.761 641 414C641 411.239 643.239 409 646 409Z",
			fill: "#0C0A0E",
			stroke: "#28282D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M598.758 57.4523L617.049 64.4999",
			stroke: "#48071D",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M611.548 51.758L604.546 70.0669",
			stroke: "#48071D",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M240.758 327.452L259.049 334.5",
			stroke: "#28282D",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.548 321.758L246.546 340.067",
			stroke: "#28282D",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M655.5 250.5V232.5H713.839L728.5 250.5V268.5H670.073L655.5 250.5Z",
			fill: "#1C1226"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M704 296V278H762.339L777 296V314H718.573L704 296Z",
			fill: "#151317"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M116 136.5V118.5H174.339L189 136.5V154.5H130.573L116 136.5Z",
			fill: "#151317"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M143 92V74H201.339L216 92V110H157.573L143 92Z",
			fill: "#28282D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182 34C185.866 34 189 37.134 189 41C189 44.866 185.866 48 182 48C178.134 48 175 44.866 175 41C175 37.134 178.134 34 182 34Z",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M654 345C657.866 345 661 348.134 661 352C661 355.866 657.866 359 654 359C650.134 359 647 355.866 647 352C647 348.134 650.134 345 654 345Z",
			stroke: "#8100FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M530 407C536.075 407 541 411.925 541 418C541 424.075 536.075 429 530 429C523.925 429 519 424.075 519 418C519 411.925 523.925 407 530 407Z",
			stroke: "#1C1226"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M479.225 169.96V256.353V299.55L450.083 342.747H411.02H342.814V256.353V213.157L371.957 169.96H411.02H479.225ZM444.502 204.683H411.02H465.273L455.273 240.182V266.017V317.688L411.02 308.024H427.761L444.502 282.189V256.353V204.683Z",
			fill: "#0C0A0E",
			stroke: "#90919C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M284.18 310.32L255.47 339.03H203.38L175 310.32V281.94H207.67V310.32H256.51V254.85H175V171H284.18V199.71H203.38V226.47H255.47L284.18 254.85V310.32Z",
			fill: "#0C0A0E",
			stroke: "#90919C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M293.18 310.32L264.47 339.03H207.38L179 310.32V281.94H211.67V310.32H260.51V254.85H179V171H293.18V199.71H207.38V226.47H264.47L293.18 254.85V310.32Z",
			fill: "#90919C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M483.359 169.96V256.353V299.55L454.216 342.747H415.153H346.948V256.353V213.157L376.09 169.96H415.153H483.359ZM448.636 204.683H415.153H398.412L381.67 230.518V256.353V308.024H415.153H431.894L448.636 282.189V256.353V204.683Z",
			fill: "#90919C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M652.544 169.96V256.353V299.55L623.402 342.747H584.339H516.134V256.353V213.157L545.276 169.96H584.339H652.544ZM617.822 204.683H584.339H567.598L550.856 230.518V256.353V308.024H584.339H601.08L617.822 282.189V256.353V204.683Z",
			fill: "#0C0A0E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M657.411 169.96V256.353V299.55L628.268 342.747H589.205H521V256.353V213.157L550.142 169.96H589.205H657.411ZM622.688 204.683H589.205H572.464L555.723 230.518V256.353V308.024H589.205H605.947L622.688 282.189V256.353V204.683Z",
			fill: "#90919C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392.091 236.091L405.975 249.966M406.132 236.091L392.248 249.966M422.595 236.091L436.479 249.966M436.636 236.091L422.752 249.966M397.933 278.818C402.671 273.907 408.026 271.451 413.998 271.451C419.971 271.451 425.326 273.907 430.064 278.818",
			stroke: "#90919C",
			strokeWidth: 6
		})
	]
});
export default SvgError;
